import axios from "axios";
import * as API_LINKS from '../../../configurations/links.jsx'
import {toast} from 'react-toastify';
import cookie from 'react-cookies'

export const FETCH_ADMIN_SATUAN_LIST = 'FETCH_ADMIN_SATUAN_LIST'
export const RECEIVE_ADMIN_SATUAN_LIST = 'RECEIVE_ADMIN_SATUAN_LIST'
export const FAILED_ADMIN_SATUAN_LIST = 'FAILED_ADMIN_SATUAN_LIST'


export function fetchAdminList(_data){    
    return (dispatch, getState) => {
        dispatch({type: FETCH_ADMIN_SATUAN_LIST});
        axios({
            method: 'post',
            url: API_LINKS.USER_GET_URL,
            headers: {
                Authorization: cookie.load('token')
            },
            data: _data
        })
        .then((response) => {
            // console.log(response.data.result)
             if(response.status === 200) {
                if(response.data.status === "success") {
                    dispatch( {
                        type: RECEIVE_ADMIN_SATUAN_LIST,
                        payload: response.data.result
                    })
                   
                } else {
                    dispatch({
                        type: FAILED_ADMIN_SATUAN_LIST
                    })
                    return toast.error(response.data.message);
                }
            } else {
                dispatch({
                    type: FAILED_ADMIN_SATUAN_LIST
                })
                return toast.error(response.data.message);
            }
        })
        .catch(function(error){
            if (error.response){
                dispatch({
                    type: FAILED_ADMIN_SATUAN_LIST
                })
                return toast.error(error.response.data.message);;
            }
        }
        )
        }
    }



// WEBPACK FOOTER //
// ./src/redux/actions/satuan/aSatuan-AdminSatuanList.jsx